import { EventCategory } from "@costory/types/prisma-client"

import { IconsEventsCategory } from "@costory/front/utils/events"

export const EVENT_CATEGORIES = [
  {
    category: EventCategory.BUSINESS,
    label: "Business",
    icon: IconsEventsCategory,
  },
  {
    category: EventCategory.TECHNICAL,
    label: "Technical",
    icon: IconsEventsCategory,
  },
  {
    category: EventCategory.PROVIDER,
    label: "Provider",
    icon: IconsEventsCategory,
  },
] as const

export const CATEGORY_MAP = {
  [EventCategory.BUSINESS]: "business",
  [EventCategory.TECHNICAL]: "technical",
  [EventCategory.PROVIDER]: "provider",
} as const

export const WATERFALL_CHART_LIMIT = 2
export const COST_CARD_HEIGHT = 150
export const AREA_CHART_HEIGHT = 70
